var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.6315,
    y1: 319.7873,
    x2: 544.4214,
    y2: -28.0026,
    gradientTransform: "matrix(1.0276 0 0 -1.0276 1.3545 532.0481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M503.275,281.125l-3.589,4.544c-8.068,10.217-10.739,23.686-7.18,36.208l1.561,5.492 c5.142,18.095-2.837,37.35-19.272,46.501l-4.975,2.771c-11.383,6.339-19.026,17.762-20.542,30.702l-0.67,5.719 c-2.185,18.653-16.895,33.362-35.548,35.547l-5.719,0.67c-12.94,1.516-24.363,9.158-30.702,20.542l-2.77,4.975 c-9.152,16.435-28.407,24.415-46.502,19.272l-5.491-1.56c-12.522-3.559-25.992-0.888-36.208,7.18l-4.544,3.589 c-14.73,11.633-35.52,11.633-50.251,0l-4.544-3.589c-10.217-8.068-23.686-10.739-36.208-7.18l-5.492,1.561 c-18.095,5.142-37.35-2.837-46.501-19.272l-2.771-4.975c-6.339-11.383-17.762-19.026-30.702-20.542l-5.719-0.67 c-18.653-2.185-33.362-16.895-35.547-35.548l-0.67-5.719c-1.516-12.94-9.158-24.363-20.542-30.702l-4.975-2.77 c-16.435-9.152-24.415-28.407-19.272-46.502l1.56-5.491c3.559-12.522,0.888-25.992-7.18-36.208l-3.589-4.544 c-11.633-14.73-11.633-35.52,0-50.251l3.589-4.544c8.068-10.217,10.739-23.686,7.18-36.208l-1.561-5.492 c-5.142-18.095,2.837-37.35,19.272-46.501l4.975-2.771c11.383-6.339,19.026-17.762,20.542-30.702l0.67-5.719 c2.185-18.653,16.895-33.362,35.548-35.547l5.719-0.67c12.94-1.516,24.363-9.158,30.702-20.542l2.77-4.975 c9.152-16.435,28.407-24.415,46.502-19.272l5.491,1.56c12.522,3.559,25.992,0.888,36.208-7.18l4.544-3.589 c14.73-11.633,35.52-11.633,50.251,0l4.544,3.589c10.217,8.068,23.686,10.739,36.208,7.18l5.492-1.561 c18.095-5.142,37.35,2.837,46.501,19.272l2.771,4.975c6.339,11.383,17.762,19.026,30.702,20.542l5.719,0.67 c18.653,2.185,33.362,16.895,35.547,35.548l0.67,5.719c1.516,12.94,9.158,24.363,20.542,30.702l4.975,2.77 c16.435,9.152,24.415,28.407,19.272,46.502l-1.56,5.491c-3.559,12.522-0.888,25.992,7.18,36.208l3.589,4.544 C514.908,245.604,514.908,266.394,503.275,281.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M475.629,279.897l-1.299,1.645c-7.674,9.717-10.215,22.529-6.83,34.439l0.552,1.941 c4.892,17.211-2.7,35.526-18.331,44.23l-1.751,0.975c-10.827,6.029-18.096,16.894-19.539,29.202l-0.24,2.05 c-2.078,17.741-16.07,31.734-33.811,33.811l-2.05,0.24c-12.308,1.442-23.173,8.711-29.202,19.539l-0.974,1.75 c-8.705,15.633-27.02,23.223-44.23,18.331l-1.94-0.552c-11.91-3.385-24.722-0.845-34.439,6.83l-1.644,1.299 c-14.011,11.065-33.785,11.065-47.796,0l-1.645-1.299c-9.717-7.674-22.529-10.215-34.439-6.83l-1.941,0.552 c-17.211,4.892-35.526-2.7-44.23-18.331l-0.975-1.751c-6.029-10.827-16.894-18.096-29.203-19.539l-2.05-0.24 c-17.741-2.078-31.734-16.07-33.811-33.811l-0.24-2.05c-1.442-12.308-8.711-23.173-19.539-29.202l-1.75-0.974 c-15.632-8.705-23.223-27.02-18.331-44.23l0.552-1.94c3.385-11.91,0.845-24.722-6.83-34.439l-1.299-1.644 c-11.065-14.011-11.065-33.785,0-47.796l1.299-1.645c7.674-9.717,10.215-22.529,6.83-34.439l-0.552-1.941 c-4.892-17.211,2.7-35.526,18.331-44.23l1.751-0.975c10.827-6.029,18.096-16.894,19.539-29.203l0.24-2.05 c2.078-17.741,16.07-31.734,33.811-33.811l2.05-0.24c12.308-1.442,23.173-8.711,29.202-19.539l0.974-1.75 c8.705-15.632,27.02-23.223,44.23-18.331l1.94,0.552c11.91,3.385,24.722,0.845,34.439-6.83l1.644-1.299 c14.011-11.065,33.785-11.065,47.796,0l1.645,1.299c9.717,7.674,22.529,10.215,34.439,6.83l1.941-0.552 c17.211-4.892,35.526,2.7,44.23,18.331l0.975,1.751c6.029,10.827,16.894,18.096,29.202,19.539l2.05,0.24 c17.741,2.078,31.734,16.07,33.811,33.811l0.24,2.05c1.442,12.308,8.711,23.173,19.539,29.203l1.75,0.974 c15.633,8.705,23.223,27.02,18.331,44.23l-0.552,1.94c-3.385,11.91-0.845,24.722,6.83,34.439l1.299,1.644 C486.693,246.112,486.693,265.886,475.629,279.897z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.9715,
    y1: 386.4474,
    x2: 451.4815,
    y2: 64.9374,
    gradientTransform: "matrix(1.0276 0 0 -1.0276 1.3545 532.0481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M460.624,279.231l-0.057,0.071c-7.46,9.446-9.93,21.901-6.64,33.48l0.004,0.014 c4.755,16.731-2.624,34.535-17.82,42.998h-0.001c-10.525,5.861-17.592,16.423-18.994,28.389l-0.007,0.06 c-2.02,17.247-15.622,30.849-32.869,32.869l-0.059,0.007c-11.965,1.402-22.528,8.469-28.389,18.994l0,0 c-8.463,15.197-26.267,22.575-42.998,17.82l-0.013-0.004c-11.578-3.29-24.033-0.821-33.48,6.64l-0.071,0.057 c-13.62,10.756-32.843,10.756-46.464,0l-0.071-0.057c-9.446-7.46-21.901-9.93-33.48-6.64l-0.014,0.004 c-16.731,4.755-34.535-2.624-42.998-17.82v-0.001c-5.861-10.525-16.423-17.592-28.389-18.994l-0.06-0.007 c-17.247-2.02-30.849-15.622-32.869-32.869l-0.007-0.059c-1.402-11.965-8.469-22.528-18.994-28.389l0,0 c-15.197-8.463-22.575-26.267-17.82-42.998l0.004-0.013c3.291-11.578,0.821-24.033-6.64-33.48l-0.057-0.071 c-10.756-13.62-10.756-32.843,0-46.464l0.057-0.071c7.46-9.446,9.93-21.901,6.64-33.48l-0.004-0.014 c-4.755-16.731,2.624-34.535,17.82-42.998h0.001c10.525-5.861,17.592-16.423,18.994-28.389l0.007-0.06 c2.02-17.247,15.622-30.849,32.869-32.869l0.059-0.007c11.965-1.402,22.528-8.469,28.389-18.994l0,0 c8.463-15.197,26.267-22.575,42.998-17.82l0.013,0.004c11.578,3.291,24.033,0.821,33.48-6.64l0.071-0.057 c13.62-10.756,32.843-10.756,46.464,0l0.071,0.057c9.446,7.46,21.901,9.93,33.48,6.64l0.014-0.004 c16.731-4.755,34.535,2.624,42.998,17.82v0.001c5.861,10.525,16.423,17.592,28.389,18.994l0.06,0.007 c17.247,2.02,30.849,15.622,32.869,32.869l0.007,0.059c1.402,11.965,8.469,22.528,18.994,28.389l0,0 c15.197,8.463,22.575,26.267,17.82,42.998l-0.004,0.013c-3.29,11.578-0.821,24.033,6.64,33.48l0.056,0.071 C471.38,246.387,471.38,265.611,460.624,279.231z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.4425,
    y1: 208.9783,
    x2: 165.7025,
    y2: 350.7183,
    gradientTransform: "matrix(1.0276 0 0 -1.0276 1.3545 532.0481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M414.551,274l-0.043,0.055c-5.78,7.32-7.694,16.969-5.144,25.941l0.003,0.011 c3.684,12.964-2.033,26.759-13.807,33.316h-0.001c-8.155,4.541-13.631,12.725-14.717,21.997l-0.005,0.046 c-1.565,13.363-12.105,23.903-25.468,25.468l-0.045,0.005c-9.271,1.086-17.456,6.561-21.997,14.717l0,0 c-6.557,11.775-20.352,17.493-33.316,13.807l-0.01-0.003c-8.971-2.55-18.622-0.636-25.942,5.144l-0.055,0.043 c-10.554,8.334-25.449,8.334-36.002,0l-0.055-0.043c-7.32-5.78-16.969-7.694-25.941-5.144l-0.011,0.003 c-12.964,3.684-26.759-2.033-33.316-13.807v-0.001c-4.541-8.155-12.725-13.631-21.997-14.717l-0.046-0.005 c-13.363-1.565-23.903-12.105-25.468-25.468l-0.005-0.045c-1.086-9.271-6.561-17.456-14.717-21.997l0,0 c-11.775-6.557-17.493-20.352-13.807-33.316l0.003-0.01c2.55-8.971,0.636-18.622-5.144-25.942L97.451,274 c-8.334-10.554-8.334-25.449,0-36.002l0.043-0.055c5.78-7.32,7.694-16.969,5.144-25.941l-0.003-0.011 c-3.684-12.964,2.033-26.759,13.808-33.316h0.001c8.155-4.541,13.631-12.725,14.717-21.997l0.005-0.046 c1.565-13.363,12.105-23.903,25.468-25.468l0.045-0.005c9.271-1.086,17.456-6.562,21.997-14.717l0,0 c6.557-11.775,20.352-17.493,33.316-13.807l0.01,0.003c8.971,2.55,18.622,0.636,25.942-5.144l0.055-0.043 c10.554-8.334,25.449-8.334,36.002,0l0.055,0.043c7.32,5.78,16.969,7.694,25.941,5.144l0.011-0.003 c12.964-3.684,26.759,2.033,33.316,13.808v0.001c4.541,8.155,12.725,13.631,21.997,14.717l0.046,0.005 c13.363,1.565,23.903,12.105,25.468,25.468l0.005,0.045c1.086,9.271,6.561,17.456,14.717,21.997l0,0 c11.775,6.557,17.493,20.352,13.807,33.316l-0.003,0.01c-2.55,8.971-0.636,18.622,5.144,25.942l0.043,0.055 C422.886,248.552,422.886,263.446,414.551,274z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.3343,
    y1: 112.4802,
    x2: 76.4044,
    y2: 317.4202,
    gradientTransform: "matrix(1.0276 0 0 -1.0276 1.3545 532.0481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE600",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M321.878,492.506l5.491,1.56c18.095,5.142,37.35-2.837,46.502-19.272l2.77-4.975 c6.339-11.383,17.762-19.026,30.702-20.542l5.719-0.67c3.238-0.379,6.354-1.144,9.309-2.233L167.827,191.832 c-1.844-1.008-4.072-1.515-6.684-1.515c-2.614,0-4.843,0.507-6.684,1.515c-1.844,1.011-2.763,2.526-2.763,4.545v41.945 c-0.054-0.042-0.11-0.094-0.163-0.134l-45.644-45.644c-2.021-1.484-4.696-2.228-8.022-2.228c-6.299,0-9.446,2.08-9.446,6.238 v117.817c0,1.902,0.95,3.417,2.852,4.545l186.64,186.64c1.096-0.706,2.17-1.462,3.211-2.284l4.544-3.589 C295.886,491.618,309.355,488.947,321.878,492.506z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.7055,
    y1: 319.6978,
    x2: 124.7055,
    y2: 122.4578,
    gradientTransform: "matrix(1.0276 0 0 -1.0276 1.3545 532.0481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF4C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M88.422,314.373V196.556c0-4.158,3.147-6.238,9.446-6.238c3.325,0,5.999,0.744,8.022,2.228 c2.018,1.487,4.099,4.309,6.238,8.467l39.569,77.178v-81.813c0-2.019,0.92-3.534,2.763-4.545c1.841-1.008,4.069-1.515,6.684-1.515 c2.612,0,4.84,0.507,6.684,1.515c1.84,1.011,2.763,2.526,2.763,4.545v117.996c0,1.902-0.922,3.417-2.763,4.545 c-1.844,1.13-4.072,1.694-6.684,1.694c-4.99,0-8.734-2.317-11.229-6.951l-42.6-81.099v81.813c0,1.902-0.921,3.417-2.762,4.545 c-1.844,1.13-4.073,1.694-6.685,1.694c-2.495,0-4.695-0.563-6.594-1.694C89.371,317.79,88.422,316.275,88.422,314.373z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.2801,
    y1: 127.4859,
    x2: 104.2401,
    y2: 390.5159,
    gradientTransform: "matrix(1.0276 0 0 -1.0276 1.3545 532.0481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE600",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M270.581,192.812c-1.07-1.663-2.614-2.495-4.635-2.495h-63.454 c-2.259,0-4.219,0.565-5.882,1.694c-1.666,1.13-2.495,2.645-2.495,4.545v117.817c0,1.902,0.83,3.417,2.495,4.545l168.4,166.776 c3.49-3.025,6.508-6.683,8.857-10.901l2.77-4.975c6.339-11.383,17.762-19.026,30.702-20.542l5.719-0.67 c18.653-2.185,33.362-16.894,35.548-35.547l0.67-5.719c1.038-8.857,4.948-17.002,10.962-23.295L270.581,192.812z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.5625,
    y1: 319.6978,
    x2: 225.5625,
    y2: 122.4578,
    gradientTransform: "matrix(1.0276 0 0 -1.0276 1.3545 532.0481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF4C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M194.116,314.373V196.556c0-1.899,0.83-3.415,2.495-4.545 c1.663-1.128,3.623-1.694,5.882-1.694h63.454c2.019,0,3.565,0.832,4.635,2.495c1.07,1.666,1.605,3.565,1.605,5.703 c0,2.378-0.566,4.397-1.694,6.06c-1.131,1.666-2.646,2.495-4.545,2.495H213.01v40.818h27.449c1.899,0,3.415,0.744,4.545,2.228 c1.127,1.487,1.693,3.298,1.693,5.436c0,1.902-0.534,3.596-1.604,5.08c-1.07,1.487-2.615,2.228-4.635,2.228H213.01v40.995h52.937 c1.899,0,3.415,0.832,4.545,2.495c1.127,1.665,1.694,3.684,1.694,6.06c0,2.139-0.535,4.041-1.605,5.703 c-1.07,1.665-2.615,2.495-4.635,2.495h-63.454c-2.259,0-4.219-0.563-5.882-1.694C194.946,317.79,194.116,316.275,194.116,314.373z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 470.9733,
    y1: 154.7291,
    x2: 313.2633,
    y2: 312.4291,
    gradientTransform: "matrix(1.0276 0 0 -1.0276 1.3545 532.0481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE600",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M503.275,281.125c0.664-0.841,1.285-1.702,1.872-2.579l-85.293-86.03 c-2.484-1.465-5.141-2.197-7.976-2.197c-3.665,0-5.851,1.272-6.559,3.816l-18.214,63.694l-27.007-25.263l-0.11-0.431 c-0.93-3.754-3.949-5.634-9.057-5.634c-5.342,0-8.416,1.844-9.229,5.526l-1.327,5.275l-43.95-43.062 c-0.713-2.612-2.913-3.921-6.595-3.921c-2.852,0-5.526,0.744-8.021,2.228c-2.495,1.487-3.744,3.298-3.744,5.436 c0,0.832,0.059,1.426,0.179,1.782l35.47,115.5c0.593,2.022,2.019,3.596,4.278,4.723l117.999,117.999 c6.841-6.382,11.466-15.106,12.616-24.927l0.67-5.719c1.516-12.94,9.158-24.363,20.542-30.702l4.975-2.771 c16.435-9.152,24.415-28.407,19.272-46.501l-1.561-5.492c-3.559-12.522-0.888-25.991,7.18-36.208L503.275,281.125z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.068,
    y1: 319.6978,
    x2: 340.068,
    y2: 122.4578,
    gradientTransform: "matrix(1.0276 0 0 -1.0276 1.3545 532.0481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF4C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M278.067,197.981c0-2.139,1.248-3.949,3.744-5.436c2.495-1.484,5.169-2.228,8.021-2.228 c3.682,0,5.882,1.309,6.595,3.921l29.231,101.598l16.045-63.81c0.813-3.682,3.888-5.526,9.229-5.526c5.108,0,8.127,1.88,9.057,5.634 l16.217,63.81l29.114-101.812c0.708-2.542,2.894-3.816,6.559-3.816c2.835,0,5.492,0.733,7.976,2.197 c2.482,1.464,3.724,3.25,3.724,5.358c0,0.821-0.062,1.407-0.179,1.757l-35.258,115.509c-0.704,2.061-2.2,3.665-4.487,4.816 c-2.285,1.15-4.78,1.726-7.475,1.726c-2.699,0-5.192-0.562-7.478-1.684c-2.285-1.122-3.665-2.69-4.132-4.701l-13.705-53.93 l-13.535,53.832c-0.466,2.041-1.829,3.632-4.094,4.773c-2.268,1.14-4.81,1.71-7.628,1.71c-2.818,0-5.358-0.565-7.614-1.694 c-2.259-1.127-3.685-2.702-4.278-4.723l-35.47-115.5C278.125,199.408,278.067,198.814,278.067,197.981z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.d6e807b8ec28768e0f18ebb93233e95b.svg";
export { ForwardRef as ReactComponent };